import { LibraryItemTypes } from './library-item-types.const'

export const LibraryItemIcon = {
  [LibraryItemTypes.THIRD_PARTY_COST]: 'view_week',
  [LibraryItemTypes.DELIVERABLE]: 'description',
  [LibraryItemTypes.COMPONENT]: 'view_agenda',
  [LibraryItemTypes.FOLDER]: 'folder',
}
